import styled from 'styled-components';

export const ContainerTable = styled.div`
  margin-top: 30px;
  .MuiDataGrid-cell.greenCell {
    background-color: #b3dab6;
  }
  .table .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;
